import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessFeatureStockRules
export interface IUserAccessFeatureStockRules {
  add: ICrudOptions;
  deletion: ICrudOptions;
  disable: ICrudOptions;
  enable: ICrudOptions;
  lineColours: ICrudOptions;
  multiplePriceChanges: ICrudOptions;
  priceBanding: ICrudOptions;
  stockTags: ICrudOptions;
  stockThreshold: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_ADD
export const _DEFAULT_USER_ACCESS_STOCK_RULES_ADD: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_DELETION
export const _DEFAULT_USER_ACCESS_STOCK_RULES_DELETION: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_DISABLE
export const _DEFAULT_USER_ACCESS_STOCK_RULES_DISABLE: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_ENABLE
export const _DEFAULT_USER_ACCESS_STOCK_RULES_ENABLE: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_LINE_COLOURS
export const _DEFAULT_USER_ACCESS_STOCK_RULES_LINE_COLOURS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_TAGS
export const _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_TAGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_THRESHOLD
export const _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_THRESHOLD: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_PRICE_BANDING
export const _DEFAULT_USER_ACCESS_STOCK_RULES_PRICE_BANDING: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULES_MULTIPLE_PRICE_CHANGES
export const _DEFAULT_USER_ACCESS_STOCK_RULES_MULTIPLE_PRICE_CHANGES: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_RULE
export const _DEFAULT_USER_ACCESS_STOCK_RULES: Readonly<IUserAccessFeatureStockRules & Object> = {
  add: {..._DEFAULT_USER_ACCESS_STOCK_RULES_ADD},
  deletion: {..._DEFAULT_USER_ACCESS_STOCK_RULES_DELETION},
  disable: {..._DEFAULT_USER_ACCESS_STOCK_RULES_DISABLE},
  enable: {..._DEFAULT_USER_ACCESS_STOCK_RULES_ENABLE},
  lineColours: {..._DEFAULT_USER_ACCESS_STOCK_RULES_LINE_COLOURS},
  multiplePriceChanges: {..._DEFAULT_USER_ACCESS_STOCK_RULES_MULTIPLE_PRICE_CHANGES},
  priceBanding: {..._DEFAULT_USER_ACCESS_STOCK_RULES_PRICE_BANDING},
  stockTags: {..._DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_TAGS},
  stockThreshold: {..._DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_THRESHOLD},
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_FEATURE_STOCK_RULES
export const _DEFAULT_USER_ACCESS_FEATURE_STOCK_RULES: Readonly<IUserAccessFeatureStockRules & Object> = {
  add: _DEFAULT_USER_ACCESS_STOCK_RULES_ADD,
  deletion: _DEFAULT_USER_ACCESS_STOCK_RULES_DELETION,
  disable: _DEFAULT_USER_ACCESS_STOCK_RULES_DISABLE,
  enable: _DEFAULT_USER_ACCESS_STOCK_RULES_ENABLE,
  lineColours: _DEFAULT_USER_ACCESS_STOCK_RULES_LINE_COLOURS,
  multiplePriceChanges: _DEFAULT_USER_ACCESS_STOCK_RULES_MULTIPLE_PRICE_CHANGES,
  priceBanding: _DEFAULT_USER_ACCESS_STOCK_RULES_PRICE_BANDING,
  stockTags: _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_TAGS,
  stockThreshold: _DEFAULT_USER_ACCESS_STOCK_RULES_STOCK_THRESHOLD,
};
//#endregion
